const STATE_EMPTY = 'empty';
const STATE_BUFFERING = 'buffering';
const STATE_BUFFERED = 'buffered';
const STATE_LOADED = 'fully-loaded';
const STATE_ERROR = 'error';
const STATE_DESTROYED = 'destroyed';


export default class WebBuffer {
    constructor() {
        this._audio = document.createElement('audio');
        this._audio.style.display = 'none';
        this._audio.crossOrigin = 'anonymous';
        this._audio.setAttribute('data-audio-type', 'buffer');
        document.body.appendChild(this._audio)

        this._state = STATE_EMPTY;


        this._emptyListener = () => this._state = STATE_EMPTY;
        this._errorListener = () => this._state = STATE_ERROR;
        this._canplayListener = () => this._state = STATE_BUFFERED;
        this._loadstartListener = () => this._state = STATE_BUFFERING;
        this._loadedListener = () => this._state = STATE_LOADED;

        this._registerHandlers();
    }

    getState() {
        return this._state;
    }

    getAudioElement() {
        return this._audio;
    }

    getUri() {
        if (this._audio) {
            return this._audio.src;
        }
        return null;
    }

    setSource(uri) {
        this._audio.src = uri;
        this._audio.load();
    }

    ready() {
        return this._state == STATE_BUFFERED || this._state == STATE_LOADED;
    }

    releaseAudioElement() {
        if (this._state == STATE_DESTROYED) {
            return;
        }
        this._unregisterHandlers();
        this._audio = null;
        this._state = STATE_DESTROYED;
    }

    destroy() {
        if (this._state == STATE_DESTROYED) {
            return;
        }
        if (this._audio) {
            this._audio.remove();
            this._audio = null;
        }
        this._state = STATE_DESTROYED;
    }


    _registerHandlers() {
        this._audio.addEventListener('emptied', this._emptyListener);
        this._audio.addEventListener('error', this._errorListener);
        this._audio.addEventListener('canplay', this._canplayListener);
        this._audio.addEventListener('loadstart', this._loadstateListener);
        this._audio.addEventListener('canplaythrough', this._loadedListener);
    }

    _unregisterHandlers() {
        this._audio.removeEventListener('emptied', this._emptyListener);
        this._audio.removeEventListener('error', this._errorListener);
        this._audio.removeEventListener('canplay', this._canplayListener);
        this._audio.removeEventListener('loadstart', this._loadstateListener);
        this._audio.removeEventListener('canplaythrough', this._loadedListener);
    }
}





// WEBPACK FOOTER //
// ./src/WebBuffer.js